import React from "react";
import Card from "./Card";

const Activity = ({ activity }) => {
  return (
    <div className="col-12 mb-4">
          <div className="row">
            {activity.cards.map((card, index) => (
              <Card key={index} card={card} />
            ))}
          </div>
    </div>
  );
};

export default Activity;
